import * as yup from 'yup';
import { requiredErrorMessage } from 'shared/consts';

export const validationSchema = yup.object().shape({
  name_ru: yup.string().required(requiredErrorMessage),
  name_kz: yup.string().required(requiredErrorMessage),
  name_uz: yup.string().required(requiredErrorMessage),
  name_kg: yup.string().required(requiredErrorMessage),
  description_ru: yup.string().required(requiredErrorMessage),
  description_kz: yup.string().required(requiredErrorMessage),
  description_uz: yup.string().required(requiredErrorMessage),
  description_kg: yup.string().required(requiredErrorMessage),
  category: yup.string().required(requiredErrorMessage),
  image: yup
    .mixed()
    .nullable()
    .test('isNull', 'Поле с картинкой обязательно для заполнения', (value) => value !== null),
  icon: yup
    .mixed()
    .nullable()
    .test('isNull', 'Поле с иконкой, обязательно к заполнению', (value) => value !== null),
  is_generated: yup.boolean(),
  prize_file: yup
    .mixed()
    .test('isGenerated', 'Обязательно если не стоит чекбокс "Генерация таблицы"', function (value) {
      // eslint-disable-next-line
      const isEditPage = location.pathname.split('/').length === 4;
      const isGenerated = this.resolve(yup.ref('is_generated'));
      if (!isGenerated && !isEditPage) {
        return !!value;
      }

      return true;
    })
    .test('format', 'Файл может быть только в формате .xlsx или .xls', function (value) {
      // eslint-disable-next-line
      const isEditPage = location.pathname.split('/').length === 4;
      const isGenerated = this.resolve(yup.ref('is_generated'));
      if (isGenerated) {
        return true;
      }
      if (!isGenerated && isEditPage && value === null) {
        return true;
      }
      if (!isGenerated) {
        if (value instanceof File) {
          const fileExtension = value.name.split('.').pop()?.toLowerCase();
          return fileExtension === 'xlsx' || fileExtension === 'xls';
        }
      }
    })
    .nullable(),
  min_start_date: yup
    .string()
    .test('required', requiredErrorMessage, function (value) {
      // eslint-disable-next-line
      const isEditPage = location.pathname.split('/').length === 4;
      const prizeFile = this.resolve(yup.ref('prize_file'));
      const isGenerated = this.resolve(yup.ref('is_generated'));
      if (isEditPage && (!prizeFile || !isGenerated) && value) {
        return true;
      }
      if (!isEditPage && !value) {
        return false;
      }
      if (!isEditPage && value) {
        return true;
      }
    })
    .test('min_max_date', 'Не может быть позже окончания', function (value) {
      const maxEndDate = this.resolve(yup.ref('max_end_date'));
      if (!maxEndDate || !value) {
        return true;
      }
      return value <= maxEndDate;
    })
    .nullable(),
  max_end_date: yup
    .string()
    .test('required', requiredErrorMessage, function (value) {
      // eslint-disable-next-line
      const isEditPage = location.pathname.split('/').length === 4;
      const prizeFile = this.resolve(yup.ref('prize_file'));
      const isGenerated = this.resolve(yup.ref('is_generated'));
      if (isEditPage && (!prizeFile || !isGenerated) && value) {
        return true;
      }
      if (!isEditPage && !value) {
        return false;
      }
      if (!isEditPage && value) {
        return true;
      }
    })
    .test('max_min_date', 'Не может быть раньше начала', function (value) {
      const minStartDate = this.resolve(yup.ref('min_start_date'));
      if (!minStartDate || !value) {
        return true;
      }
      return value >= minStartDate;
    })
    .nullable(),
});
